import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-13.1a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8m-1.3 1.95a1.3 1.3 0 1 1 2.6 0v6.9a1.3 1.3 0 1 1-2.6 0z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }